<template>
  <!-- 已选 -->
  <div
    class="JD-SelectBar"
    @click.stop
  >
    <div
      v-if="chooseCategory && chooseCategory.name || activeBrand"
      class="selected row"
    >
      <span>{{TLang('已选','my')}}</span>
      <ul>
        <li v-if="chooseCategory.name">
          <span>{{TLang('分类','my')}}</span>
          <span>{{ chooseCategory.name == '全部'? currentFirstName : chooseCategory.name }}</span>
          <i
            class="icon iconfont"
            @click="chooseAllGoods"
          >&#xe65d;</i>
        </li>
        <li v-if="activeBrand">
          {{ TLang('品牌','my') + '：' + activeBrand }}
          <i
            class="icon iconfont"
            @click="delBrand"
          >&#xe65d;</i>
        </li>
      </ul>
    </div>
    <div
      v-if="chooseCategory && chooseCategory.name || activeBrand"
      class="line"
    ></div>
    <div
      class="JD-category category row"
    >
      <span>{{TLang('分类','my')}}</span>
      <div class="JD-wrap ">
        <div
          :class="['all-book', ID_TYPE === 'ALL' && 'all-goods']"
          @click="chooseAllGoods"
          @mousedown="activeHover = {}"
        >
          {{TLang('全部','my')}}
        </div>
        <div
          v-for="book in catList"
          :key="book.id"
          :class="['JD-item', ID_TYPE === 'ONE' && bookId == book.id && 'active']"
          @click="clickBookItem(book.id)"
        >
          {{ book.name }}
        </div>
      </div>
    </div>
    <!-- 品牌 -->
    <div
      v-if="brandList && brandList.length"
      class="brands row"
    >
      <span>{{TLang('品牌','my')}}</span>
      <ul
        :style="{height: showMoreBrand ? 'auto' : '40px'}"
        :class="{showMoreBrand}"
      >
        <li
          :class="{active: !activeBrand}"
          @click="delBrand"
        >
          {{TLang('全部','my')}}
        </li>
        <li
          v-for="(brand,index) in brandList"
          :key="index"
          :class="[activeBrand === brand.text && 'active']"
          :style="{display: brand.name.trim() ? 'block': 'none'}"
          @click="onBrandsChange(brand)"
        >
          {{ brand.text }}
        </li>
      </ul>
      <div
        v-if="brandList.length >= 12"
        class="hideBottom"
      >
        <span
          @click="showMoreBrand = !showMoreBrand"
        >{{ showMoreBrand ? TLang('收起','my') : TLang('展开','my') }}</span>
        <i :class="showMoreBrand && 'down'"></i>
      </div>
    </div>
  </div>
</template>

<script>
// 所有入口的校验
import { getQueryString } from '@utils';
import { healthChannelId } from '@utils/config';
export default {
  props: {
    catList: {
      type: Array,
      default: function() {
        return [];
      },
    },
    channelCode:{
      type: Number,
      default:2,
    }, // 凑单页区分图书
    onBrandChange: Function,
    onCateChange: Function,
    brandList: {
      type: Array,
      default: function() {
        return [];
      },
    },
    chooseAll: Function,
    selectType:String, //list分类列表 add凑单
  },
  data() {
    return {
      activeHover: {},
      chooseCategory: {},
      activeBrand: null, //选中的品牌
      channelId: getQueryString('channelId') || '999', //分类页区分图书
      goodsType: getQueryString('goodsType') || '0',
      bookId: getQueryString('categoryId') || '0',
      showMoreBrand: false, // 品牌展开
      ID_TYPE: 'ONE', // ONE 一级分类id  ALL无id 全部
      healthChannelId: healthChannelId,
      currentFirstName: '', //当前选中的一级分类的name
    };
  },
  mounted() {
    if(getQueryString('mId')){
      this.ID_TYPE = 'ALL';
    };
    this.init();
    let filterBrand = this.brandList.filter(brand => brand.name === getQueryString('bn') );
    if(filterBrand.length){
      this.activeBrand = getQueryString('bn');
    };
  },
  methods: {
    init() {
      // 根据url 挑选出已选
      if(getQueryString('categoryId')){
        this.catList.filter(item => {
          if(item.id == getQueryString('categoryId')){
            this.chooseCategory = item;
            this.ID_TYPE = 'ONE';
          }
        });
      }else {
        this.chooseCategory = {};
        this.ID_TYPE = 'ALL';
      }
      this.activeHover = this.chooseCategory;
    },

    // 点击全部
    chooseAllGoods(){
      this.ID_TYPE = 'ALL';
      this.chooseCategory = {};
      this.activeHover = {};
      this.activeBrand = null;
      this.currentFirstName = '';
      this.chooseAll();
    },

    // 切换品牌 清除了搜索条件
    onBrandsChange(brand) {
      this.$router.push({
        path: '/product/JDList',
        query: {
          ...this.$route.query,
          bn: brand.name,
          // keyword: null,
        },
      });
      this.activeBrand = brand.text;
      this.onBrandChange(brand.name);

    },
    // 点击一级分类 单选
    clickBookItem(id){
      if(id){
        this.$router.push({
          path: '/product/JDList',
          query: {
            ...this.$route.query,
            categoryId: id,
            channelId: '999',
            bn: null,
          },
        });
      }else{
        this.$router.push({
          path: '/product/JDList',
          query: {
            channelId: '999',
            bn: null,
          },
        });
      }

      setTimeout(() => {
        window.location.reload();
      }, 300);
    },
    // 清除品牌
    delBrand(){
      this.activeBrand = null;
      this.onBrandChange(null);
      this.$router.push({
        path: '/product/JDList',
        query: {
          ...this.$route.query,
          bn: null,
          // keyword: null,
        },
      });
    },
  },
};
</script>

<style lang="less">
.JD-SelectBar {
  padding: 12px 0px;
  border: 1px solid rgba(229, 229, 229, 1) !important;
  width: 100%;
  box-sizing: border-box;
  padding-top: 0;
  .row {
    display: flex;
    align-items: center;
    padding: 0 24px;
    span {
      font-size: 14px;
      color: #666;
      line-height: 26px;
      white-space: nowrap;
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      margin-left: 10px;
      li {
        color: #666;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
  .selected {
    margin-bottom: 2px;
    ul {
      padding-top: 12px;
      li {
        border: 1px solid rgba(229, 229, 229, 1);
        padding: 0 5px;
        line-height: 26px;
        margin-right: 10px;
        margin-bottom: 12px;
        &:hover{
          border-color: #3d96e2;
          i{
            color: #3d96e2;
          }
        }
        i {
          line-height: 11px;
        }
      }
    }
  }
  .line{
    background-color: #f7f7f7;
  }
  .category {
    position: relative;
    padding-right: 0;
    align-items: baseline;
    ul {
      flex-wrap: wrap;
      overflow: hidden;
      align-items: center;
      li {
        display: flex;
        align-items: center;
        line-height: 40px;
        padding-left: 12px;
        padding-right: 18px;
        height: 40px;
        cursor: pointer;
        span{
          color: #333;
        }
        .hasMore {
          display: inline-block;
          border: 5px solid transparent;
          border-top: 5px solid #3d96e2;
          width: 0;
          height: 0;
          transform: translate(5px, 3px);
          border-top-color: #999;
          transform-style: preserve-3d;
          -webkit-perspective: 1000;
          -moz-perspective: 1000;
          -ms-perspective: 1000;
          perspective: 1000;
        }
        &:hover{
          span{
            color:rgba(61,150,226,1);
          }
          .hasMore {
            border-top-color: #3d96e2;
          }
        }
      }
      li.all-goods{
        padding: 0 8px;
        width:44px;
        height:24px;
        background:rgba(61,150,226,1);
        border-radius:2px;
        box-sizing: border-box;
        color: #fff;
        font-size:14px;
        margin-right: 10px;
        cursor: pointer;
        &:hover{
          color: #fff;
        }
      }
      .activeHover {
        span {
          color: #3d96e2;
        }
        .hasMore {
          border-top-color: #3d96e2;
          transform-origin: center;
        }
      }
      li.active {
        background:rgba(61,150,226,0.05);
        span{
          color:rgba(61,150,226,1);
        }
        .hasMore {
          border-top-color: #3d96e2;
          transform: rotate(180deg) translate(-5px, 2px);
        }
      }
    }
  }
  .JD-category{
    margin-top: 10px;
    margin-bottom: 10px;
    .JD-wrap{
      margin-left: 14px;
      display: flex;
      flex-wrap:wrap;
      .all-book{
        display: flex;
        align-items: center;
        line-height: 28px;
        padding: 0 8px;
        height: 40px;
        margin-right: 10px;
        cursor: pointer;
        &:hover{
          color: #4679A3;
        }
      }
      .all-book ~ div{
        height: 40px;
        line-height: 40px;
      }
      .all-goods{
        padding: 0 8px;
        width:44px;
        height:28px;
        background:#4679A3;
        border-radius:2px;
        box-sizing: border-box;
        color: #fff;
        font-size:14px;
        margin-right: 10px;
        margin-bottom: 12px;
        cursor: pointer;
        &:hover{
          color: #fff;
        }
      }
      .all-goods ~ div{
        height: 28px;
        line-height: 28px;
      }
      .JD-item{
        font-size:14px;
        font-family:MicrosoftYaHei;
        color:rgba(51,51,51,1);
        margin-right: 10px;
        padding: 0 8px;
        height: 28px;
        line-height: 28px;
        &:hover{
          cursor: pointer;
          color: #4679A3;
        }
      }
      .JD-item.active{
        background:rgba(70,121,163,0.05);
        border-radius:2px;
        color: #4679A3;
        height: 40px;
        line-height: 40px;
      }
    }
  }
  .brands {
    align-items: baseline;
    transition: all 1s ease-in;
    position: relative;
    ul {
      align-items: center;
      flex-wrap: wrap;
      height: 40px;
      overflow: hidden;
      line-height: 44px;
      transition: all 1s ease-in;
      width: 1050px;
      margin-left: 14px;
      li {
        font-size: 14px;
        color: #333;
        margin-right: 10px;
        margin-bottom: 15px;
        padding: 0 8px;
        line-height: 28px;
      }
      .active {
        color: #fff;
        background:#4679A3;
        border-radius:2px;
        line-height: 28px;
      }
    }
    div.hideBottom{
      position: absolute;
      right: 20px;
      top: 0;
      span{
        color: #222;

      }
      i{
        position: relative;
        top: 1px;
        display: inline-block;
        vertical-align: middle;
        width: 0;
        height: 0;
        line-height: 0;
        font-size: 0;
        border-width: 5px;
        border-style: solid;
        border-color: #333 transparent transparent;
      }
      i.down{
        transform: rotate(180deg) translateY(50%);
        transition: none;

      }
      &:hover{
        cursor: pointer;
        span{
          color: #3D96E2;
        }
        i{
          border-color: #3D96E2 transparent transparent;
        }
      }
    }
    ul.showMoreBrand{
      max-height: 100px;
      overflow-y: scroll;
      scrollbar-color: #ededed transparent;
      scrollbar-track-color: #ccc;
      -ms-scrollbar-track-color: transparent;
      scrollbar-width: 3px;
      -ms-scrollbar-width: 3px;
    }
  }
}
</style>
